import { render } from "./Noticias.vue?vue&type=template&id=6cb51d1a"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__